import { useAppSelector } from "../store/hook";
import { ApiResponse, User } from "../types";
import { apiRequestWithAuth } from "./api";

export const createUser = async (userData: FormData): Promise<ApiResponse<User>> => {
    return await apiRequestWithAuth("/user/add", "POST", userData);
};

export const getUser = async (userId: number): Promise<ApiResponse<User>> => {
    return await apiRequestWithAuth("/user/" + userId, "GET");
};